import { Component, OnInit, Input } from '@angular/core';

@Component({
  selector: 'app-bread-crumb',
  templateUrl: './bread-crumb.component.html',
  styleUrls: ['./bread-crumb.component.less']
})
export class BreadCrumbComponent implements OnInit {

  @Input() breadcrumbLabel: string;
  @Input() breadcrumbLink: string;

  constructor() { }

  ngOnInit() {
  }

}
